import { DefaultMonthsColumns } from "../../../Utils/DefaultData";

export const DatosEditablesSolidos =
{
    InventarioInicial: { rowName: 'Inventario Inicial', ...DefaultMonthsColumns },
    AjustesDRCCompVsDRCProc: { rowName: '(-) Ajustes DRC comp vs DRC proc.', ...DefaultMonthsColumns, isNegative: true },
    SKIMParaSolidos: { rowName: '(+) SKIM para sólidos', ...DefaultMonthsColumns },
    CoaguloLavadoPilasCentrifugas: { rowName: '(+) Coàgulo lavado pilas/centrifugas', ...DefaultMonthsColumns },
    CoagulosDeTrampas: { rowName: '(+) Coàgulos de trampas', ...DefaultMonthsColumns },
    CoagulosCentrifugado: { rowName: '(+) Coàgulos centrifugado', ...DefaultMonthsColumns },
    ProduccionFinca: { rowName: '(+) Produccion Finca', ...DefaultMonthsColumns },
    ComprasImportadas: { rowName: '(+) Compras Importadas', ...DefaultMonthsColumns },
    ComprasProdExportadora: { rowName: '(+) Compras Prod-Exportador', ...DefaultMonthsColumns },
    ComprasDelMes: { rowName: '(+) Compras del mes', ...DefaultMonthsColumns },
}

export const TotalesSolidos =
{
    // CtoPromedioDelInvenTotal: { rowName: 'Cto. Promedio del Inven. Total', ...DefaultMonthsColumns },
    SalidasAProduccion: { rowName: 'Salidas a producción', ...DefaultMonthsColumns },
    // InventarioFinal: { rowName: 'Inventario Final', ...DefaultMonthsColumns },
}

export const SolidosData = {
    ...DatosEditablesSolidos,
    ...TotalesSolidos
}

export const EditableRowNames = Object.keys(DatosEditablesSolidos);

export const TotalRowNames = [
    'Cto. Promedio del Inven. Total',
    'Salidas a producción',
    'Inventario Final'
]
